import { render, staticRenderFns } from "./CarVMSPUAudit.vue?vue&type=template&id=bbc751c0&scoped=true"
import script from "./CarVMSPUAudit.vue?vue&type=script&lang=ts"
export * from "./CarVMSPUAudit.vue?vue&type=script&lang=ts"
import style0 from "./CarVMSPUAudit.vue?vue&type=style&index=0&id=bbc751c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc751c0",
  null
  
)

export default component.exports